import React, { useState, useEffect } from 'react';
import Dashboard from './pages/Dashboard';
import CreateDispatch from './pages/CreateDispatch';
import Login from './pages/Login';
import OnboardingChecklist from './components/OnboardingChecklist';
import socketService from './services/socket';

function App() {
  const [user, setUser] = useState(null);
  const [currentPage, setCurrentPage] = useState('dashboard');

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
      socketService.connect();
    }
  }, []);

  const handleLoginSuccess = (userData) => {
    setUser(userData);
    socketService.connect();
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    socketService.disconnect();
    setUser(null);
  };

  if (!user) {
    return <Login onLoginSuccess={handleLoginSuccess} />;
  }

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f9fafb' }}>
      {/* Navigation Bar */}
      <nav style={{
        backgroundColor: '#1e40af',
        color: 'white',
        padding: '16px 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '32px' }}>
          <h1 style={{ margin: 0, fontSize: '24px', fontWeight: 'bold' }}>Dispurtch</h1>
          <div style={{ display: 'flex', gap: '16px' }}>
            <button
              onClick={() => setCurrentPage('dashboard')}
              style={{
                background: currentPage === 'dashboard' ? 'rgba(255,255,255,0.2)' : 'none',
                border: 'none',
                color: 'white',
                padding: '8px 16px',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Dashboard
            </button>
            {(user.role === 'customer' || user.role === 'dispatcher' || user.role === 'admin') && (
              <button
                onClick={() => setCurrentPage('create')}
                style={{
                  background: currentPage === 'create' ? 'rgba(255,255,255,0.2)' : 'none',
                  border: 'none',
                  color: 'white',
                  padding: '8px 16px',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Create Dispatch
              </button>
            )}
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <span style={{ fontSize: '14px' }}>
            {user.name} ({user.role})
          </span>
          <button
            onClick={handleLogout}
            style={{
              backgroundColor: 'rgba(255,255,255,0.2)',
              border: 'none',
              color: 'white',
              padding: '8px 16px',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Logout
          </button>
        </div>
      </nav>

      {/* Main Content */}
      <div>
        {currentPage === 'dashboard' && <OnboardingChecklist />}
        {currentPage === 'dashboard' && <Dashboard />}
        {currentPage === 'create' && <CreateDispatch onSuccess={() => setCurrentPage('dashboard')} />}
      </div>
    </div>
  );
}

export default App;
